import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Button } from '../Button';
import HStack from '../HStack';
import Modal from './Modal';
import FocusLock from 'react-focus-lock';
import { ModalHeaderProps } from './ModalHeader';
import { keyCodes } from '../../constants/keycodes';

interface ModalProps extends ModalHeaderProps {
  show: boolean;
  children?: React.ReactNode;
  title?: string;
  buttonOkLabel?: string;
  buttonCancelLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  height?: string[] | string | number[] | number | undefined;
  buttonOkVariant?: string;
  buttonCancelVariant?: string;
  backgroundColor?: string;
  color?: string;
}
const GlobalStyle = createGlobalStyle({
  html: {
    overflowY: 'hidden',
  },
});

export const ModalConfirm = ({
  show,
  children,
  title,
  buttonOkLabel = 'Sí',
  buttonCancelLabel = 'No',
  onConfirm,
  onCancel,
  buttonOkVariant = 'white',
  buttonCancelVariant = 'white',
  backgroundColor = 'primary.0',
  color = 'white',
  height = '100%',
  ...rest
}: ModalProps) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (!event) return;

    event.key === keyCodes.Escape && onCancel?.();
  };

  if (!show) return <></>;

  return (
    <FocusLock>
      <Modal role="dialog" aria-hidden="false" aria-modal="true" aria-labelledby="modal-body">
        <GlobalStyle />
        <Modal.Window role="document" maxHeight={height} bg={backgroundColor} color={color} tabIndex={0}>
          <Modal.Window.Header title={title} onClose={onCancel} color={color} />
          <Modal.Window.Body>{children}</Modal.Window.Body>
          <HStack justifyContent="center">
            <Button onClick={onConfirm} fit={'small'} type="button" variant={buttonOkVariant} marginRight="24px">
              {buttonOkLabel}
            </Button>
            <Button onClick={onCancel} onKeyDown={onKeyDown} fit={'small'} type="button" variant={buttonCancelVariant}>
              {buttonCancelLabel}
            </Button>
          </HStack>
        </Modal.Window>
      </Modal>
    </FocusLock>
  );
};

ModalConfirm.displayName = 'ModalConfirm';
